import React from 'react';
import './App.css';
import logo from './assets/loraframe-logo.png';
const App = () => {
  return (
      <div className="app">
        <div className="background">
          <header className="header">
            <div className="container-header">
              <div className="logo-container">
                <img src={logo} alt="Loraframe logo" className="logo-image" />
                <h1 className="logo">loraframe</h1>
              </div>
              <button 
                className="menu-button" 
                onClick={() => window.location.href = 'mailto:tryloraframe@gmail.com'}
              >
                Contact
              </button>
            </div>
          </header>

          <main>
            <section className="hero">
              <div className="container">
                <h2 className="hero-title">Every product deserves a story.</h2>
                <p className="hero-subtitle">
                  Loraframe helps you create privacy-focused AI-generated video advertisements for unreleased and newly launched products.
                </p>
                <button className="hero-button">Book a Demo</button>
              </div>
            </section>
          </main>
        </div>

        <footer className="footer">
          <div className="container">
            <p>&copy; 2025 Loraframe. All rights reserved.</p>
          </div>
        </footer>
      </div>
  );
};

export default App;

